import Vue from "vue";
import Vuex from "vuex";

import gamepadInfo from "../data/gamepadInfo.json";
import gamepadPresets from "../data/gamepadPresets.json";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        gamepad: null,
        gamepadType: 'generic',
        gamepadConnection: false,
        gamepadPresets: gamepadPresets.presets,
        scroll: false,
        scrollPos: window.scrollY
    },
    getters: {
        gamepad: ( state ) => state.gamepad,
        gamepadType: ( state ) => state.gamepad ? state.gamepadType : 'none',
        gamepadConnection: ( state ) => state.gamepadConnection,
        gamepadPresets: ( state ) => state.gamepadPresets,
        gamepadVibration: ( state ) => !!state.gamepad.vibrationActuator,
        scroll: ( state ) => state.scroll,
        scrollPos: ( state ) => state.scrollPos
    },
    actions: {
        setGamepad( { commit, dispatch }, gamepad ) {
            commit( 'assignGamepad', gamepad );
            dispatch( 'setGamepadType' );
            dispatch( 'setGamepadConnection', !!gamepad || true );
        },
        setGamepadType( { state, commit } ) {
            let keys = Object.keys(gamepadInfo);
            
            let type = keys.reduce( (match, type) => {
                if ( state.gamepad && gamepadInfo[type].ids.indexOf( state.gamepad.id ) >= 0 ) {
                    match = type;
                }
                return match;
            }, null);

            if ( type ) commit( 'assignGamepadType', type );
        },
        setGamepadConnection( { state, commit }, status ) {
            commit( 'assignGamepadConnection', status );
        },
        setScroll( { state, commit }, status ) {
            commit( 'assignScroll', status );
            commit( 'assignScrollPos', window.scrollY );
        }
    }, 
    mutations: {
        assignGamepad( state, gamepad ) {
            state.gamepad = gamepad;
        },
        assignGamepadType( state, type ) {
            state.gamepadType = type;
        },
        assignGamepadConnection( state, status ) {
            state.gamepadConnection = status;
        },
        assignScroll( state, status ) {
            state.scroll = status;
        },
        assignScrollPos( state, pos ) {
            state.scrollPos = pos;
        }
    }
});
